// Frontend slug helpers — MUST stay in sync with backend/seo_routes.py:slugify()
export function slugify(value) {
  if (!value) return "";
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function spotPath(area) {
  if (!area) return "/";
  const c = slugify(area.country);
  const r = slugify(area.region);
  if (!c || !r || !area.slug) return `/surf-area/${area.slug}`;
  return `/surf-spots/${c}/${r}/${area.slug}`;
}

export function regionPath(country, region) {
  return `/surf-spots/${slugify(country)}/${slugify(region)}`;
}

export function countryPath(country) {
  return `/surf-spots/${slugify(country)}`;
}

export function beginnerPath(country, region) {
  return `/beginner-surf/${slugify(country)}/${slugify(region)}`;
}
